import React from 'react';
import { useNavigate } from "react-router-dom";
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PatternsDeviceInstalledReport = (props) => {
	const navigate = useNavigate();
	const params = useParams();
	const { t } = useTranslation('translation', { keyPrefix: 'patternsPage' });
	const reportId = params.report_id;
	let error = '';

	if (!reportId) {
		error = 'The device install report number is required.'
	} else {
		navigate('/managevehicles/installation/report', {
			state: { reportId },
		});
	}

	return (
		<article>
			{error
				&& (
					<div>
						<h3>{t('error404')}</h3>
						<div>{error}</div>
						<div>{t('goBack')} <Link to="/" className="btn">{t('btnHome')}</Link></div>
					</div>
				)}
		</article>
	)
}

export default PatternsDeviceInstalledReport;
